/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.7.0.0 (NJsonSchema v10.1.24.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

export interface IContactContractApiService {
    getAllContactContractsOfCustomer(skip?: number | undefined, take?: number | undefined, searchTerm?: string | null | undefined, orderBy?: string | null | undefined, sortDirection?: ApiSortDirection | null | undefined): Observable<ApiResponseOfIEnumerableOfContractListDto>;
    getContactContracts(contactId: string | null, skip?: number | undefined, take?: number | undefined, searchTerm?: string | null | undefined, orderBy?: string | null | undefined, sortDirection?: ApiSortDirection | null | undefined): Observable<ApiResponseOfIEnumerableOfContractDto>;
}

@Injectable({
    providedIn: 'root'
})
export class ContactContractApiService implements IContactContractApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "https://localhost:5001";
    }

    getAllContactContractsOfCustomer(skip?: number | undefined, take?: number | undefined, searchTerm?: string | null | undefined, orderBy?: string | null | undefined, sortDirection?: ApiSortDirection | null | undefined): Observable<ApiResponseOfIEnumerableOfContractListDto> {
        let url_ = this.baseUrl + "/api/Contact/contracts?";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllContactContractsOfCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllContactContractsOfCustomer(<any>response_);
                } catch (e) {
                    return <Observable<ApiResponseOfIEnumerableOfContractListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ApiResponseOfIEnumerableOfContractListDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllContactContractsOfCustomer(response: HttpResponseBase): Observable<ApiResponseOfIEnumerableOfContractListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ApiResponseOfIEnumerableOfContractListDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfIEnumerableOfContractListDto>(<any>null);
    }

    getContactContracts(contactId: string | null, skip?: number | undefined, take?: number | undefined, searchTerm?: string | null | undefined, orderBy?: string | null | undefined, sortDirection?: ApiSortDirection | null | undefined): Observable<ApiResponseOfIEnumerableOfContractDto> {
        let url_ = this.baseUrl + "/api/Contact/{contactId}/contracts?";
        if (contactId === undefined || contactId === null)
            throw new Error("The parameter 'contactId' must be defined.");
        url_ = url_.replace("{contactId}", encodeURIComponent("" + contactId));
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContactContracts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContactContracts(<any>response_);
                } catch (e) {
                    return <Observable<ApiResponseOfIEnumerableOfContractDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ApiResponseOfIEnumerableOfContractDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetContactContracts(response: HttpResponseBase): Observable<ApiResponseOfIEnumerableOfContractDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ApiResponseOfIEnumerableOfContractDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfIEnumerableOfContractDto>(<any>null);
    }
}

export interface IContactApiService {
    getContacts(skip?: number | undefined, take?: number | undefined, searchTerm?: string | null | undefined, orderBy?: string | null | undefined, sortDirection?: ApiSortDirection | null | undefined): Observable<ApiResponseOfIEnumerableOfContactListDto>;
    getContactDetails(contactId: string | null): Observable<ApiResponseOfContactDetailDto>;
    getContactBaseInformation(): Observable<ApiResponseOfContactBaseInfoDto>;
}

@Injectable({
    providedIn: 'root'
})
export class ContactApiService implements IContactApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "https://localhost:5001";
    }

    getContacts(skip?: number | undefined, take?: number | undefined, searchTerm?: string | null | undefined, orderBy?: string | null | undefined, sortDirection?: ApiSortDirection | null | undefined): Observable<ApiResponseOfIEnumerableOfContactListDto> {
        let url_ = this.baseUrl + "/api/contactsInfo?";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContacts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContacts(<any>response_);
                } catch (e) {
                    return <Observable<ApiResponseOfIEnumerableOfContactListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ApiResponseOfIEnumerableOfContactListDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetContacts(response: HttpResponseBase): Observable<ApiResponseOfIEnumerableOfContactListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ApiResponseOfIEnumerableOfContactListDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfIEnumerableOfContactListDto>(<any>null);
    }

    getContactDetails(contactId: string | null): Observable<ApiResponseOfContactDetailDto> {
        let url_ = this.baseUrl + "/api/contactsInfo/{contactId}";
        if (contactId === undefined || contactId === null)
            throw new Error("The parameter 'contactId' must be defined.");
        url_ = url_.replace("{contactId}", encodeURIComponent("" + contactId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContactDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContactDetails(<any>response_);
                } catch (e) {
                    return <Observable<ApiResponseOfContactDetailDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ApiResponseOfContactDetailDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetContactDetails(response: HttpResponseBase): Observable<ApiResponseOfContactDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ApiResponseOfContactDetailDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfContactDetailDto>(<any>null);
    }

    getContactBaseInformation(): Observable<ApiResponseOfContactBaseInfoDto> {
        let url_ = this.baseUrl + "/api/contactsInfo/base";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContactBaseInformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContactBaseInformation(<any>response_);
                } catch (e) {
                    return <Observable<ApiResponseOfContactBaseInfoDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ApiResponseOfContactBaseInfoDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetContactBaseInformation(response: HttpResponseBase): Observable<ApiResponseOfContactBaseInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ApiResponseOfContactBaseInfoDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfContactBaseInfoDto>(<any>null);
    }
}

export interface IContactOfferApiService {
    getContactOffer(): Observable<ApiResponseOfContactOfferDto>;
    getAttachment(onetimeAttachmentId: string | null): Observable<FileResponse>;
    getOneTimeAttachmentId(attachmentId: string | null): Observable<OneTimeAttachmentInfoDto>;
}

@Injectable({
    providedIn: 'root'
})
export class ContactOfferApiService implements IContactOfferApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "https://localhost:5001";
    }

    getContactOffer(): Observable<ApiResponseOfContactOfferDto> {
        let url_ = this.baseUrl + "/api/ContactOffer";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContactOffer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContactOffer(<any>response_);
                } catch (e) {
                    return <Observable<ApiResponseOfContactOfferDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ApiResponseOfContactOfferDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetContactOffer(response: HttpResponseBase): Observable<ApiResponseOfContactOfferDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ApiResponseOfContactOfferDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfContactOfferDto>(<any>null);
    }

    getAttachment(onetimeAttachmentId: string | null): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/ContactOffer/Attachments/Download/{onetimeAttachmentId}";
        if (onetimeAttachmentId === undefined || onetimeAttachmentId === null)
            throw new Error("The parameter 'onetimeAttachmentId' must be defined.");
        url_ = url_.replace("{onetimeAttachmentId}", encodeURIComponent("" + onetimeAttachmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttachment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttachment(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetAttachment(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(<any>null);
    }

    getOneTimeAttachmentId(attachmentId: string | null): Observable<OneTimeAttachmentInfoDto> {
        let url_ = this.baseUrl + "/api/ContactOffer/Attachments/OneTimeId/{attachmentId}";
        if (attachmentId === undefined || attachmentId === null)
            throw new Error("The parameter 'attachmentId' must be defined.");
        url_ = url_.replace("{attachmentId}", encodeURIComponent("" + attachmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOneTimeAttachmentId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOneTimeAttachmentId(<any>response_);
                } catch (e) {
                    return <Observable<OneTimeAttachmentInfoDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OneTimeAttachmentInfoDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetOneTimeAttachmentId(response: HttpResponseBase): Observable<OneTimeAttachmentInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <OneTimeAttachmentInfoDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OneTimeAttachmentInfoDto>(<any>null);
    }
}

export interface IContractApiService {
    getContracts(skip?: number | undefined, take?: number | undefined, searchTerm?: string | null | undefined, orderBy?: string | null | undefined, sortDirection?: ApiSortDirection | null | undefined): Observable<ApiResponseOfIEnumerableOfContractDto>;
    getContractByContractId(contractId: string | null): Observable<ApiResponseOfContractDto>;
    getContractAttachments(contractId: string | null, skip?: number | undefined, take?: number | undefined, searchTerm?: string | null | undefined, orderBy?: string | null | undefined, sortDirection?: ApiSortDirection | null | undefined): Observable<ApiResponseOfIEnumerableOfAttachmentInfoDto>;
    getOneTimeAttachmentId(contractId: string | null, attachmentId: string | null): Observable<OneTimeAttachmentInfoDto>;
    getAttachment(onetimeAttachmentId: string | null): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class ContractApiService implements IContractApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "https://localhost:5001";
    }

    getContracts(skip?: number | undefined, take?: number | undefined, searchTerm?: string | null | undefined, orderBy?: string | null | undefined, sortDirection?: ApiSortDirection | null | undefined): Observable<ApiResponseOfIEnumerableOfContractDto> {
        let url_ = this.baseUrl + "/api/contract?";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContracts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContracts(<any>response_);
                } catch (e) {
                    return <Observable<ApiResponseOfIEnumerableOfContractDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ApiResponseOfIEnumerableOfContractDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetContracts(response: HttpResponseBase): Observable<ApiResponseOfIEnumerableOfContractDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ApiResponseOfIEnumerableOfContractDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfIEnumerableOfContractDto>(<any>null);
    }

    getContractByContractId(contractId: string | null): Observable<ApiResponseOfContractDto> {
        let url_ = this.baseUrl + "/api/contract/{contractId}";
        if (contractId === undefined || contractId === null)
            throw new Error("The parameter 'contractId' must be defined.");
        url_ = url_.replace("{contractId}", encodeURIComponent("" + contractId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContractByContractId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContractByContractId(<any>response_);
                } catch (e) {
                    return <Observable<ApiResponseOfContractDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ApiResponseOfContractDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetContractByContractId(response: HttpResponseBase): Observable<ApiResponseOfContractDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ApiResponseOfContractDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfContractDto>(<any>null);
    }

    getContractAttachments(contractId: string | null, skip?: number | undefined, take?: number | undefined, searchTerm?: string | null | undefined, orderBy?: string | null | undefined, sortDirection?: ApiSortDirection | null | undefined): Observable<ApiResponseOfIEnumerableOfAttachmentInfoDto> {
        let url_ = this.baseUrl + "/api/contract/{contractId}/Attachments?";
        if (contractId === undefined || contractId === null)
            throw new Error("The parameter 'contractId' must be defined.");
        url_ = url_.replace("{contractId}", encodeURIComponent("" + contractId));
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContractAttachments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContractAttachments(<any>response_);
                } catch (e) {
                    return <Observable<ApiResponseOfIEnumerableOfAttachmentInfoDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ApiResponseOfIEnumerableOfAttachmentInfoDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetContractAttachments(response: HttpResponseBase): Observable<ApiResponseOfIEnumerableOfAttachmentInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ApiResponseOfIEnumerableOfAttachmentInfoDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfIEnumerableOfAttachmentInfoDto>(<any>null);
    }

    getOneTimeAttachmentId(contractId: string | null, attachmentId: string | null): Observable<OneTimeAttachmentInfoDto> {
        let url_ = this.baseUrl + "/api/contract/{contractId}/Attachments/OneTimeId/{attachmentId}";
        if (contractId === undefined || contractId === null)
            throw new Error("The parameter 'contractId' must be defined.");
        url_ = url_.replace("{contractId}", encodeURIComponent("" + contractId));
        if (attachmentId === undefined || attachmentId === null)
            throw new Error("The parameter 'attachmentId' must be defined.");
        url_ = url_.replace("{attachmentId}", encodeURIComponent("" + attachmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOneTimeAttachmentId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOneTimeAttachmentId(<any>response_);
                } catch (e) {
                    return <Observable<OneTimeAttachmentInfoDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OneTimeAttachmentInfoDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetOneTimeAttachmentId(response: HttpResponseBase): Observable<OneTimeAttachmentInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <OneTimeAttachmentInfoDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OneTimeAttachmentInfoDto>(<any>null);
    }

    getAttachment(onetimeAttachmentId: string | null): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/contract/Attachments/Download/{onetimeAttachmentId}";
        if (onetimeAttachmentId === undefined || onetimeAttachmentId === null)
            throw new Error("The parameter 'onetimeAttachmentId' must be defined.");
        url_ = url_.replace("{onetimeAttachmentId}", encodeURIComponent("" + onetimeAttachmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttachment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttachment(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetAttachment(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(<any>null);
    }
}

export interface ICurrentUserInfoApiService {
    getExtendedUserInfo(): Observable<ApiResponseOfExtendedUserInfoDto>;
}

@Injectable({
    providedIn: 'root'
})
export class CurrentUserInfoApiService implements ICurrentUserInfoApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "https://localhost:5001";
    }

    getExtendedUserInfo(): Observable<ApiResponseOfExtendedUserInfoDto> {
        let url_ = this.baseUrl + "/api/CurrentUserInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExtendedUserInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExtendedUserInfo(<any>response_);
                } catch (e) {
                    return <Observable<ApiResponseOfExtendedUserInfoDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ApiResponseOfExtendedUserInfoDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetExtendedUserInfo(response: HttpResponseBase): Observable<ApiResponseOfExtendedUserInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ApiResponseOfExtendedUserInfoDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfExtendedUserInfoDto>(<any>null);
    }
}

export interface ICustomerApiService {
    getCustomerInfo(): Observable<ApiResponseOfCustomerDto>;
    getCustomerContactInfo(): Observable<ApiResponseOfCustomerDto>;
}

@Injectable({
    providedIn: 'root'
})
export class CustomerApiService implements ICustomerApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "https://localhost:5001";
    }

    getCustomerInfo(): Observable<ApiResponseOfCustomerDto> {
        let url_ = this.baseUrl + "/api/Customer";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomerInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomerInfo(<any>response_);
                } catch (e) {
                    return <Observable<ApiResponseOfCustomerDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ApiResponseOfCustomerDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCustomerInfo(response: HttpResponseBase): Observable<ApiResponseOfCustomerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ApiResponseOfCustomerDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfCustomerDto>(<any>null);
    }

    getCustomerContactInfo(): Observable<ApiResponseOfCustomerDto> {
        let url_ = this.baseUrl + "/api/Customer/contactInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomerContactInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomerContactInfo(<any>response_);
                } catch (e) {
                    return <Observable<ApiResponseOfCustomerDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ApiResponseOfCustomerDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCustomerContactInfo(response: HttpResponseBase): Observable<ApiResponseOfCustomerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ApiResponseOfCustomerDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfCustomerDto>(<any>null);
    }
}

export interface INewsApiService {
    getNews(skip?: number | undefined, take?: number | undefined, searchTerm?: string | null | undefined, orderBy?: string | null | undefined, sortDirection?: ApiSortDirection | null | undefined): Observable<ApiResponseOfIEnumerableOfAttachmentCategoryDto>;
    getNewsMessages(skip?: number | undefined, take?: number | undefined, searchTerm?: string | null | undefined, orderBy?: string | null | undefined, sortDirection?: ApiSortDirection | null | undefined): Observable<ApiResponseOfIEnumerableOfAttachmentCategoryDto>;
    getOneTimeAttachmentId(attachmentId: string | null): Observable<OneTimeAttachmentInfoDto>;
    getAttachment(onetimeAttachmentId: string | null): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class NewsApiService implements INewsApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "https://localhost:5001";
    }

    getNews(skip?: number | undefined, take?: number | undefined, searchTerm?: string | null | undefined, orderBy?: string | null | undefined, sortDirection?: ApiSortDirection | null | undefined): Observable<ApiResponseOfIEnumerableOfAttachmentCategoryDto> {
        let url_ = this.baseUrl + "/api/News?";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNews(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNews(<any>response_);
                } catch (e) {
                    return <Observable<ApiResponseOfIEnumerableOfAttachmentCategoryDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ApiResponseOfIEnumerableOfAttachmentCategoryDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetNews(response: HttpResponseBase): Observable<ApiResponseOfIEnumerableOfAttachmentCategoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ApiResponseOfIEnumerableOfAttachmentCategoryDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfIEnumerableOfAttachmentCategoryDto>(<any>null);
    }

    getNewsMessages(skip?: number | undefined, take?: number | undefined, searchTerm?: string | null | undefined, orderBy?: string | null | undefined, sortDirection?: ApiSortDirection | null | undefined): Observable<ApiResponseOfIEnumerableOfAttachmentCategoryDto> {
        let url_ = this.baseUrl + "/api/News/messages?";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNewsMessages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNewsMessages(<any>response_);
                } catch (e) {
                    return <Observable<ApiResponseOfIEnumerableOfAttachmentCategoryDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ApiResponseOfIEnumerableOfAttachmentCategoryDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetNewsMessages(response: HttpResponseBase): Observable<ApiResponseOfIEnumerableOfAttachmentCategoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ApiResponseOfIEnumerableOfAttachmentCategoryDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfIEnumerableOfAttachmentCategoryDto>(<any>null);
    }

    getOneTimeAttachmentId(attachmentId: string | null): Observable<OneTimeAttachmentInfoDto> {
        let url_ = this.baseUrl + "/api/News/Attachments/OneTimeId/{attachmentId}";
        if (attachmentId === undefined || attachmentId === null)
            throw new Error("The parameter 'attachmentId' must be defined.");
        url_ = url_.replace("{attachmentId}", encodeURIComponent("" + attachmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOneTimeAttachmentId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOneTimeAttachmentId(<any>response_);
                } catch (e) {
                    return <Observable<OneTimeAttachmentInfoDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OneTimeAttachmentInfoDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetOneTimeAttachmentId(response: HttpResponseBase): Observable<OneTimeAttachmentInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <OneTimeAttachmentInfoDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OneTimeAttachmentInfoDto>(<any>null);
    }

    getAttachment(onetimeAttachmentId: string | null): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/News/Attachments/Download/{onetimeAttachmentId}";
        if (onetimeAttachmentId === undefined || onetimeAttachmentId === null)
            throw new Error("The parameter 'onetimeAttachmentId' must be defined.");
        url_ = url_.replace("{onetimeAttachmentId}", encodeURIComponent("" + onetimeAttachmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttachment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttachment(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetAttachment(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(<any>null);
    }
}

export interface IRequestLoginApiService {
    requestNewLoginCredentials(requestLoginDto: RequestLoginDto): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class RequestLoginApiService implements IRequestLoginApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "https://localhost:5001";
    }

    requestNewLoginCredentials(requestLoginDto: RequestLoginDto): Observable<void> {
        let url_ = this.baseUrl + "/api/RequestLogin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestLoginDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestNewLoginCredentials(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestNewLoginCredentials(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processRequestNewLoginCredentials(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

export interface IThemingApiService {
    getTheme(companySubdomain?: string | null | undefined): Observable<ApiResponseOfThemeInfoDto>;
}

@Injectable({
    providedIn: 'root'
})
export class ThemingApiService implements IThemingApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "https://localhost:5001";
    }

    getTheme(companySubdomain?: string | null | undefined): Observable<ApiResponseOfThemeInfoDto> {
        let url_ = this.baseUrl + "/api/Theming?";
        if (companySubdomain !== undefined && companySubdomain !== null)
            url_ += "companySubdomain=" + encodeURIComponent("" + companySubdomain) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTheme(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTheme(<any>response_);
                } catch (e) {
                    return <Observable<ApiResponseOfThemeInfoDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ApiResponseOfThemeInfoDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetTheme(response: HttpResponseBase): Observable<ApiResponseOfThemeInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ApiResponseOfThemeInfoDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfThemeInfoDto>(<any>null);
    }
}

export interface IThemingImageApiService {
    getImage(companySubdomain?: string | null | undefined, imageType?: string | null | undefined): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class ThemingImageApiService implements IThemingImageApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "https://localhost:5001";
    }

    getImage(companySubdomain?: string | null | undefined, imageType?: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/ThemingImage?";
        if (companySubdomain !== undefined && companySubdomain !== null)
            url_ += "companySubdomain=" + encodeURIComponent("" + companySubdomain) + "&";
        if (imageType !== undefined && imageType !== null)
            url_ += "imageType=" + encodeURIComponent("" + imageType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetImage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetImage(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetImage(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(<any>null);
    }
}

export interface IInfoApiService {
    /**
     * Get api info
     */
    get(): Observable<ApiResponseOfApiInfo>;
}

@Injectable({
    providedIn: 'root'
})
export class InfoApiService implements IInfoApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "https://localhost:5001";
    }

    /**
     * Get api info
     */
    get(): Observable<ApiResponseOfApiInfo> {
        let url_ = this.baseUrl + "/api/info";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<ApiResponseOfApiInfo>><any>_observableThrow(e);
                }
            } else
                return <Observable<ApiResponseOfApiInfo>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ApiResponseOfApiInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ApiResponseOfApiInfo>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfApiInfo>(<any>null);
    }
}

export interface IAuthApiService {
    /**
     * Logs in a user
     */
    login(dto: LoginDto): Observable<ApiResponseOfLoginResultDto>;
    /**
     * Logs out a user
     */
    logout(dto: LogoutDto): Observable<ApiResponse>;
    /**
     * Renews a token
     */
    renewToken(dto: TokenRenewalDto): Observable<ApiResponseOfTokenRenewalResultDto>;
    /**
     * Gets permissions
     */
    getPermissions(): Observable<ApiResponseOfIEnumerableOfPermissionDto>;
}

@Injectable({
    providedIn: 'root'
})
export class AuthApiService implements IAuthApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "https://localhost:5001";
    }

    /**
     * Logs in a user
     */
    login(dto: LoginDto): Observable<ApiResponseOfLoginResultDto> {
        let url_ = this.baseUrl + "/api/Auth/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogin(<any>response_);
                } catch (e) {
                    return <Observable<ApiResponseOfLoginResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ApiResponseOfLoginResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processLogin(response: HttpResponseBase): Observable<ApiResponseOfLoginResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ApiResponseOfLoginResultDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfLoginResultDto>(<any>null);
    }

    /**
     * Logs out a user
     */
    logout(dto: LogoutDto): Observable<ApiResponse> {
        let url_ = this.baseUrl + "/api/Auth/logout";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogout(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogout(<any>response_);
                } catch (e) {
                    return <Observable<ApiResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<ApiResponse>><any>_observableThrow(response_);
        }));
    }

    protected processLogout(response: HttpResponseBase): Observable<ApiResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponse>(<any>null);
    }

    /**
     * Renews a token
     */
    renewToken(dto: TokenRenewalDto): Observable<ApiResponseOfTokenRenewalResultDto> {
        let url_ = this.baseUrl + "/api/Auth/renew";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRenewToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRenewToken(<any>response_);
                } catch (e) {
                    return <Observable<ApiResponseOfTokenRenewalResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ApiResponseOfTokenRenewalResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processRenewToken(response: HttpResponseBase): Observable<ApiResponseOfTokenRenewalResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ApiResponseOfTokenRenewalResultDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponseOfModelStateDictionary>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfTokenRenewalResultDto>(<any>null);
    }

    /**
     * Gets permissions
     */
    getPermissions(): Observable<ApiResponseOfIEnumerableOfPermissionDto> {
        let url_ = this.baseUrl + "/api/Auth/permissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPermissions(<any>response_);
                } catch (e) {
                    return <Observable<ApiResponseOfIEnumerableOfPermissionDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ApiResponseOfIEnumerableOfPermissionDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetPermissions(response: HttpResponseBase): Observable<ApiResponseOfIEnumerableOfPermissionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ApiResponseOfIEnumerableOfPermissionDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfIEnumerableOfPermissionDto>(<any>null);
    }
}

export interface ApiResponse {
    success?: boolean;
    message?: string | null;
    count?: number | null;
    maxCount?: number | null;
}

export interface ApiResponseOfIEnumerableOfContractListDto extends ApiResponse {
    data?: ContractListDto[] | null;
}

export interface ContractListDto {
    contractId?: string | null;
    name?: string | null;
    lastName?: string | null;
    firstName?: string | null;
    salutation?: string | null;
    birthday?: string | null;
    personelNumber?: number | null;
    type?: string | null;
    status?: string | null;
    insuranceCertificateNumber?: string | null;
    start?: string | null;
    end?: string | null;
    editStatus?: string | null;
    implementationCompany?: string | null;
}

export enum ApiSortDirection {
    Ascending = "Ascending",
    Descending = "Descending",
}

export interface ApiResponseOfIEnumerableOfContractDto extends ApiResponse {
    data?: ContractDto[] | null;
}

export interface ContractDto {
    contractId?: string | null;
    name?: string | null;
    salutation?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    birthday?: string | null;
    personelNumber?: number | null;
    type?: string | null;
    status?: string | null;
    insuranceCertificateNumber?: string | null;
    start?: string | null;
    end?: string | null;
    editStatus?: string | null;
    contribution?: number | null;
    paymentType?: string | null;
    implementationCompany?: string | null;
    implementationType?: string | null;
    dateOfShipmentPolicy?: string | null;
    guaranteedRent?: number | null;
    totalRent?: number | null;
    guaranteedCapitalContribution?: number | null;
    totalCapitalContribution?: number | null;
    contactContribution?: number | null;
    customerContribution?: number | null;
    customerContributionAVWL?: number | null;
    customerGrant?: number | null;
}

export interface ApiResponseOfIEnumerableOfContactListDto extends ApiResponse {
    data?: ContactListDto[] | null;
}

export interface ContactListDto {
    id?: string;
    salutation?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    birthday?: string | null;
    personelNumber?: number | null;
    office?: string | null;
    consultingState?: string | null;
    firstConsultingDate?: string | null;
    employeeSince?: string | null;
}

export interface ApiResponseOfContactDetailDto extends ApiResponse {
    data?: ContactDetailDto | null;
}

export interface ContactDetailDto {
    id?: string;
    salutation?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    birthday?: string | null;
    phone?: string | null;
    mobile?: string | null;
    fax?: string | null;
    email?: string | null;
    phonePrivate?: string | null;
    emailPrivate?: string | null;
    address?: string | null;
    zipCode?: string | null;
    city?: string | null;
    subCountry?: string | null;
    country?: string | null;
    personelNumber?: number | null;
    office?: string | null;
    consultingState?: string | null;
    firstConsultingDate?: string | null;
    employeeSince?: string | null;
}

export interface ApiResponseOfContactBaseInfoDto extends ApiResponse {
    data?: ContactBaseInfoDto | null;
}

export interface ContactBaseInfoDto {
    customer?: CustomerDto;
    id?: string;
    salutation?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    birthday?: string | null;
    phone?: string | null;
    mobile?: string | null;
    fax?: string | null;
    email?: string | null;
    phonePrivate?: string | null;
    emailPrivate?: string | null;
    address?: string | null;
    zipCode?: string | null;
    city?: string | null;
    subCountry?: string | null;
    country?: string | null;
    personelNumber?: number | null;
    consultingState?: string | null;
    firstConsultingDate?: string | null;
    employeeSince?: string | null;
    office?: string | null;
}

export interface CustomerDto {
    displayName?: string | null;
    additionalName?: string | null;
    shortName?: string | null;
    address?: string | null;
    zipCode?: string | null;
    city?: string | null;
    region?: string | null;
    country?: string | null;
    fax?: string | null;
    email?: string | null;
    website?: string | null;
    contactCount?: number | null;
    phone?: string | null;
}

export interface ApiResponseOfContactOfferDto extends ApiResponse {
    data?: ContactOfferDto | null;
}

export interface ContactOfferDto {
    welcomeMessage?: string;
    introduction?: string;
    informationFiles?: AttachmentCategoryDto[];
}

export interface AttachmentCategoryDto {
    name?: string;
    startDate?: string | null;
    endDate?: string | null;
    attachments?: AttachmentInfoDto[];
}

export interface AttachmentInfoDto {
    id?: string;
    displayName?: string;
    description?: string | null;
    size?: number;
    creationDate?: string;
    updateDate?: string | null;
    notes?: string | null;
}

export interface OneTimeAttachmentInfoDto {
    oneTimeId?: string;
    validUntil?: string;
}

export interface ApiResponseOfContractDto extends ApiResponse {
    data?: ContractDto | null;
}

export interface ApiResponseOfIEnumerableOfAttachmentInfoDto extends ApiResponse {
    data?: AttachmentInfoDto[] | null;
}

export interface ApiResponseOfExtendedUserInfoDto extends ApiResponse {
    data?: ExtendedUserInfoDto | null;
}

export interface ExtendedUserInfoDto {
    userName?: string | null;
    userDisplayName?: string | null;
    customerDisplayName?: string | null;
    userType?: UserType;
}

export enum UserType {
    Customer = 0,
    Contact = 1,
}

export interface ApiResponseOfCustomerDto extends ApiResponse {
    data?: CustomerDto | null;
}

export interface ApiResponseOfIEnumerableOfAttachmentCategoryDto extends ApiResponse {
    data?: AttachmentCategoryDto[] | null;
}

export interface RequestLoginDto {
    username?: string;
    password?: string;
    firstname?: string;
    lastname?: string;
    email?: string;
    birthday?: string;
    telephone?: string;
    employer?: string;
}

export interface ApiResponseOfThemeInfoDto extends ApiResponse {
    data?: ThemeInfoDto | null;
}

export interface ThemeInfoDto {
    companyName?: string;
    primaryColor?: string;
    accentColor?: string;
    primaryContrastColor?: string;
    accentContrastColor?: string;
}

export interface ApiResponseOfApiInfo extends ApiResponse {
    data?: ApiInfo | null;
}

export interface ApiInfo {
    name?: string;
    version?: string;
    environment?: string;
    buildTimeUtc?: string;
}

export interface ApiResponseOfLoginResultDto extends ApiResponse {
    data?: LoginResultDto | null;
}

export interface LoginResultDto {
    tokenData?: TokenRenewalResultDto | null;
    isUserDisabled?: boolean;
}

export interface TokenRenewalResultDto {
    token?: string;
    refreshToken?: string;
    validUntil?: string;
    user?: UserDto;
}

export interface BaseDto {
    id?: number | null;
    created?: string | null;
    lastChange?: string | null;
}

export interface UserDto extends BaseDto {
    username?: string | null;
    firstname?: string | null;
    lastname?: string | null;
    passwordHash?: string | null;
    passwordSalt?: string | null;
    isEnabled?: boolean;
    isPasswordChangeRequired?: boolean;
    permissions?: string[] | null;
}

export interface LoginDto {
    username: string;
    password: string;
}

export interface LogoutDto {
    refreshToken: string;
}

export interface ApiResponseOfTokenRenewalResultDto extends ApiResponse {
    data?: TokenRenewalResultDto | null;
}

export interface ApiResponseOfModelStateDictionary extends ApiResponse {
    data?: ModelStateDictionary | null;
}

export interface ModelStateDictionary {
    Root?: ModelStateEntry | null;
    MaxAllowedErrors?: number;
    HasReachedMaxErrors?: boolean;
    ErrorCount?: number;
    Count?: number;
    Keys?: string[];
    Values?: ModelStateEntry[];
    IsValid?: boolean;
    ValidationState?: ModelValidationState;
    Item?: ModelStateEntry | null;
}

export interface ModelStateEntry {
    rawValue?: any | null;
    attemptedValue?: string | null;
    errors?: ModelError[] | null;
    validationState?: ModelValidationState;
}

export interface ModelError {
    exception?: Exception | null;
    errorMessage?: string | null;
}

export interface Exception {
    StackTrace?: string | null;
    Message?: string;
    InnerException?: Exception | null;
    Source?: string | null;
}

export enum ModelValidationState {
    Unvalidated = 0,
    Invalid = 1,
    Valid = 2,
    Skipped = 3,
}

export interface TokenRenewalDto {
    username: string;
    refreshToken: string;
}

export interface ApiResponseOfIEnumerableOfPermissionDto extends ApiResponse {
    data?: PermissionDto[] | null;
}

export interface PermissionDto {
    key?: string;
    translations?: { [key: string]: PermissionTranslationDto; };
}

export interface PermissionTranslationDto {
    title?: string;
    description?: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((<any>event.target).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}